var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M4 11q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.942v-8q0-.55.391-.941Q3.45.333 4 .333h6q.55 0 .942.392.39.391.391.941v8q0 .55-.391.942A1.28 1.28 0 0 1 10 11zm0-1.334h6v-8H4zm-2.667 4q-.55 0-.941-.391A1.28 1.28 0 0 1 0 12.333V3.666q0-.283.192-.475A.65.65 0 0 1 .667 3q.283 0 .475.191a.65.65 0 0 1 .191.475v8.667H8q.283 0 .475.192a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191z"
  })));
};
export default SvgIconCopy;